// @flow

import * as React from "react";
import QrScanner from "qr-scanner";
import Modal from "../organisms/Modal";
import TextButton from "../atoms/TextButton";
import Loader from "../atoms/Loader";
import Icon from "../atoms/Icon";
import useAsyncState from "../../hooks/useAsyncState";

type PropsType = {
    active: boolean,
    onScanned: Function,
    onClose: Function,
    attendee?: {
        checked_in: boolean,
        name: string,
        ticketType: string,
        email: string,
    },
    error?: any,
};

const QrScannerModal = (props: PropsType): React.Node => {
    return (
        <Modal
            aside={true}
            active={props.active}
            className="qr-scanner-modal"
            onClose={props.onClose}
            onOverlayClick={props.onClose}
        >
            <Modal.Header>Scan QR Code</Modal.Header>
            <Modal.Content>
                <QrScannerModalInner
                    onClose={props.onClose}
                    onScanned={props.onScanned}
                    error={props.error}
                />
            </Modal.Content>
        </Modal>
    );
};

const QrScannerModalInner = (props: PropsType): React.Node => {
    const videoRef = React.useRef();
    const [state, localActions] = useAsyncState();
    const [scanner, setScanner] = React.useState(null);
    const [result, setResult] = React.useState(null);

    // on mount use effect
    React.useEffect(() => {
        if (!state.error) {
            localActions.request();

            QrScanner.hasCamera()
                .then(hasCamera => {
                    if (hasCamera) {
                        setScanner(
                            new QrScanner(
                                videoRef.current,
                                qrResult => {
                                    if (qrResult) {
                                        setResult(qrResult);
                                    }
                                },
                                {
                                    highlightScanRegion: !result ? true : false,
                                }
                            )
                        );
                    } else {
                        setDeviceSupportError();
                    }
                })
                .catch(error => {
                    setDeviceSupportError();
                });
        }
        return () => {
            destroyScanner();
        };
    }, []); // eslint-disable-line

    // new scanner setup use effect
    React.useEffect(() => {
        if (scanner) {
            try {
                scanner
                    .start()
                    .then(() => {
                        // final camera success
                        localActions.success();
                    })
                    .catch(error => {
                        setDeviceSupportError();
                    });
            } catch (error) {
                setDeviceSupportError();
            }
            return () => scanner.stop();
        }
    }, [scanner]); // eslint-disable-line

    // new result mount effect
    React.useEffect(() => {
        if (result) {
            // scanner.stop();
            destroyScanner();

            props.onScanned(result);
        }
    }, [result]); // eslint-disable-line

    // external error (from check in) use effect
    React.useEffect(() => {
        if (props.error) {
            destroyScanner();
            localActions.fail(props.error);
        }
    }, [props.error]); // eslint-disable-line

    const destroyScanner = () => {
        if (scanner) {
            scanner.stop();
            // scanner.destroy();
        }
        // setScanner(null);
        // setResult(false);
    };

    const setDeviceSupportError = () => {
        localActions.fail(
            "Device does not have camera/support. Or camera access may need to be enabled in your device and browser privacy settings."
        );
    };

    const closeModal = () => {
        if (scanner) {
            // scanner.stop();
            // scanner.destroy();
            // setScanner(null);
            // setResult(false);
        }
        props.onClose();
    };

    return (
        <div className="container-fluid qr-scanner-modal__content__inner">
            <div className="row">
                <div className="col-xs-12">
                    <Loader className="center-xs" active={state.loading} />

                    {!state.error ? (
                        <div
                            className={`qr-scanner-modal__video__container ${
                                state.loading ? "is-loading" : ""
                            }`}
                        >
                            <video
                                className="qr-scanner-modal__video"
                                ref={videoRef}
                                muted
                                autoPlay
                                playsInline
                                preload="none"
                            ></video>
                        </div>
                    ) : null}

                    {!state.loading ? (
                        <>
                            {!state.error ? (
                                <></>
                            ) : (
                                <>
                                    <div className="ticket-detail-manage-modal__icon is-error">
                                        <Icon name="close" />
                                    </div>

                                    <h2 className="ticket-detail-manage-modal__heading heading-2">
                                        Check in unsuccessful
                                    </h2>

                                    <p>{state.error}</p>

                                    <br />
                                </>
                            )}

                            <p
                                className="center-xs"
                                style={{
                                    display: "flex",
                                    marginTop: "28px",
                                }}
                            >
                                <TextButton onClick={closeModal}>
                                    Back
                                </TextButton>
                            </p>
                        </>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default QrScannerModal;
